export default __webpack_public_path__ + "static/media/bad_trip.896b66b5.png";